import { Card, Group, Progress, Stack, Text, Title } from '@mantine/core'
import React from 'react'

type Props = {
  totalGoal?: number
  className?: string
  metricInfo: {
    title: string
    subTitle?: string
    metrics: Array<{
      title: string
      target?: number
      value: number
      enabled: boolean
      link?: string
    }>
  }
}

const MetricSummary: React.FC<Props> = ({ className, metricInfo }) => {
  const enabledMetrics = metricInfo.metrics.filter(({ enabled }) => enabled)

  return (
    <Card shadow='sm' padding='xl' radius='md' className={className}>
      {/* Header */}
      <Stack gap='md' mb='xl'>
        <Title order={3}>{metricInfo.title}</Title>
        {metricInfo.subTitle && (
          <Text size='sm' c='dimmed'>
            {metricInfo.subTitle}
          </Text>
        )}
      </Stack>

      {/* Metrics Overview */}
      <Group
        gap='xl'
        mb='xl'
        justify='between'
        align='center'
        style={{
          display: 'flex',
          justifyContent: enabledMetrics.length === 2 ? 'space-around' : 'space-between',
          gap: '5rem',
        }}
      >
        {enabledMetrics.map((metric, key) => (
          <Stack key={key} gap='xs' align='center' style={{ minWidth: '150px' }}>
            <Text size='sm' c='dimmed' fw={500}>
              {metric?.title}
            </Text>
            <Text size='xl' fw={700}>
              {metric?.value}
            </Text>
          </Stack>
        ))}
      </Group>

      {/* Metrics List */}
      <Stack gap='xs'>
        {metricInfo.metrics
          .filter(({ enabled }) => enabled)
          .filter((metric) => metric.target && metric.target > 0)
          .map((metric, key) => (
            <Card key={key} withBorder padding='xl' radius='md'>
              <Stack gap='md'>
                <Title order={4}>{metric.title} progress</Title>
                <Group justify='space-between' gap='xl'>
                  <Text size='xl' fw={700}>
                    {metric.target && metric.target > 0
                      ? `${Math.ceil((metric.value / metric.target) * 100)}%`
                      : ''}
                  </Text>
                  <Text size='xl' fw={700} c='dark'>
                    {metric.target} Goal
                  </Text>
                </Group>
                <Progress
                  value={(metric.value / (metric.target || 1)) * 100}
                  size='lg'
                  radius='md'
                />
              </Stack>
            </Card>
          ))}
      </Stack>
    </Card>
  )
}

export { MetricSummary }
